export function displayStatus(status) {
  const raw = String(status || '').trim()
  const map = {
    PENDING_SUPPORT_ACTION: 'Awaiting RCS Support',
    PENDING_CUSTOMER_ACTION: 'In progress',
    OPEN: 'Awaiting RCS Support',
    IN_PROGRESS: 'In progress',
    RESOLVED: 'Resolved',
    AUTO_CLOSED: 'Auto-closed',
    DEACTIVE: 'Deleted'
  }
  return map[raw] || raw || 'Open'
}

export function displaySeverity(severity) {
  if (!severity) return 'Normal'
  const raw = String(severity).trim()
  const map = {
    CRITICAL: 'Critical',
    HIGH: 'High',
    NORMAL: 'Normal',
    MEDIUM: 'Normal',
    LOW: 'Low'
  }
  return map[raw.toUpperCase()] || raw
}

export function parseJson(value) {
  if (value == null || value === '') return value
  if (typeof value === 'string') {
    try {
      return JSON.parse(value)
    } catch (error) {
      return value
    }
  }
  return value
}

function toDate(value) {
  if (!value && value !== 0) return null
  const numeric = Number(value)
  const date = !Number.isNaN(numeric)
    ? new Date(numeric < 1e12 ? numeric * 1000 : numeric)
    : new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return date
}

function formatTicketDate(value) {
  const date = toDate(value)
  if (!date) return value ? String(value) : '-'
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })
}

export function formatTicketDateTime(value) {
  const date = toDate(value)
  if (!date) return value ? String(value) : '-'
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  })
}

export function mapChatbotLogs(logs) {
  const parsed = parseJson(logs)
  if (!Array.isArray(parsed)) return []

  return parsed
    .map((item = {}) => ({
      id: item.log_id || item.id || '',
      query: item.query || item.user_query || item.question || '',
      response: item.response || item.bot_response || item.answer || '',
      ticketId: item.ticket_id || item.ticketId || '',
      userId: item.user_id || item.userId || '',
      sessionId: item.session_id || item.sessionId || '',
      userEmail: item.user_email_id || item.user_email || item.email || '',
      createdOn: item.created_on || item.created_at || item.createdOn || 0,
      time: formatTicketDateTime(item.created_on || item.created_at || item.createdOn)
    }))
    .sort((a, b) => Number(a.createdOn || 0) - Number(b.createdOn || 0))
}

function mapSenderType(item = {}) {
  const type = String(item.author_type || item.type || item.sender_type || item.role || '').toLowerCase()
  if (type.includes('bot') || type.includes('ai')) return 'bot'
  if (
    type.includes('support') ||
    type.includes('staff') ||
    type.includes('admin') ||
    type.includes('agent')
  ) {
    return 'support'
  }
  return 'user'
}

function normalizeAttachmentUrls(attachments) {
  const parsed = parseJson(attachments)
  if (!parsed) return []
  const list = Array.isArray(parsed) ? parsed : [parsed]
  return list
    .map((item) => {
      if (!item) return ''
      if (typeof item === 'string') return item.trim()
      return String(
        item.url ||
          item.file_url ||
          item.fileUrl ||
          item.presigned_url ||
          item.presignedUrl ||
          item.path ||
          ''
      ).trim()
    })
    .filter(Boolean)
}

export function mapMessages(correspondence) {
  if (!Array.isArray(correspondence)) return []
  return correspondence.map((item) => {
    const attachments = normalizeAttachmentUrls(
      item.attachments || item.attachment_urls || item.files || []
    )
    const fileUrl = item.file_url || item.fileUrl || item.file_path || item.attachment_url || ''
    if (fileUrl && !attachments.includes(fileUrl)) {
      attachments.push(fileUrl)
    }
    return {
      type: mapSenderType(item),
      sender: item.author_name || item.sender || item.sender_name || item.created_by || item.reporter_name || '',
      author_name: item.author_name || '',
      time: formatTicketDate(item.created_on || item.created_at || item.time || item.timestamp),
      text: item.message || item.text || item.body || item.description || '',
      attachments
    }
  })
}

export function mapTicket(raw = {}) {
  const ticket = raw.ticket || raw
  const correspondence = raw.correspondence || ticket.correspondence || raw.messages || []
  const statusRaw = ticket.ticket_status || ticket.statusRaw || ticket.status
  const ticketId = ticket.ticket_id || ticket.ticketId
  return {
    ticketId,
    caseId: ticket.ticket_number || ticket.case_id || ticket.caseId || ticketId || '-',
    subject: ticket.title || ticket.subject || ticket.ticket_title || 'Untitled case',
    meta: ticket.module || ticket.source || '',
    status: displayStatus(statusRaw),
    statusRaw,
    severity: displaySeverity(ticket.severity),
    created: formatTicketDate(ticket.created_on || ticket.created_at || ticket.created),
    updated: formatTicketDate(ticket.last_activity_on || ticket.updated_at || ticket.last_updated || ticket.updated),
    assignedTo: ticket.assigned_to_name || ticket.assigned_to || ticket.assignee || '-',
    reporter: ticket.reporter_name || '',
    reporterEmail: ticket.reporter_email || ticket.created_by || '',
    messages: mapMessages(correspondence),
    chatbotLogs: mapChatbotLogs(ticket.chatbot_logs || raw.chatbot_logs || []),
    raw: ticket
  }
}
